import { gql } from '@apollo/client';

export const QUERY_CLASSE_INFO = gql`
  query GetCurrentClasseInfo {
    getCurrentClasseInfos {
      name
      filiere
      niveau
      lycee
      nbProfs
      nbEleves
      debut
      fin
      noteclasse {
        qteca
      }
      objectif {
        name
        ca
      }
    }
  }
`;
